import React from "react";
import { observer } from "mobx-react-lite";
import { Form } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { formatDate, formatDateTime } from "utils/localizations";
import type PaymentBankTransferDetailViewModel from "viewModels/finance/payments/bankTransfer/paymentBankTransferDetailViewModel";
import Section from "views/common/section";

export interface OperatingDataInfoProps {
  vm: PaymentBankTransferDetailViewModel;
}

const OperatingDataInfo = observer((props: OperatingDataInfoProps) => {
  const { vm } = props;

  return (
    <Section title={vm.translate("operatingDataInfoTitle")} context>
      <Form.Row as={Col} sm={6}>
        <Form.Group as={Col} sm={6}>
          <Form.Label>{vm.translate("statementDate")}</Form.Label>
          <FakeInput target={vm.item} property="statementDate" valueFormatter={value => formatDate(value)} />
        </Form.Group>
        <Form.Group as={Col} sm={6}>
          <Form.Label>{vm.translate("createdAt")}</Form.Label>
          <FakeInput target={vm.item} property="createdAt" valueFormatter={value => formatDateTime(value)} />
        </Form.Group>
      </Form.Row>
    </Section>
  );
});

export default OperatingDataInfo;
